import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </Tag>
  );
};

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.06em] -mb-[0.06em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionHead = ({ index, title, className = "" }) => (
  <FadeUp className={`flex items-end gap-4 border-b border-white/10 pb-4 ${className}`}>
    <span className="font-display text-pink text-lg leading-none" data-testid={`section-index-${index}`}>{index}</span>
    <h2 className="font-display text-4xl sm:text-5xl leading-none tracking-wide">{title}</h2>
  </FadeUp>
);
